<template>
  <el-dialog
    :visible.sync="modelValue"
    width="340px"
    title
    append-to-body
    custom-class="relic-upload-cropper"
  >
    <div class="cropper-contant">
      <vue-cropper
        ref="cropper"
        :img="coverUrl"
        :outputSize="option.size"
        :outputType="option.outputType"
        :info="option.info"
        :canScale="option.canScale"
        :autoCrop="option.autoCrop"
        :autoCropWidth="option.autoCropWidth"
        :autoCropHeight="option.autoCropHeight"
        :fixedNumber="option.fixedNumber"
        :canMoveBox="option.canMoveBox"
        :canMove="option.canMove"
        :fixedBox="option.fixedBox"
      />
    </div>
    <div class="cropper-control">
      <el-button @click="handleChangeSmall(-5)">-</el-button>
      <div class="block">
        <el-slider
          @change="handleChangeSize"
          v-model="proportionValue"
          :show-tooltip="false"
        ></el-slider>
      </div>
      <el-button @click="handleChangeBigger(5)">+</el-button>
      <span
        class="iconfont icon-xiangzuoxuanzhuan"
        @click="handleChangeLeft"
      ></span>
      <span
        class="iconfont icon-xiangyouxuanzhuan"
        @click="handleChangeRight"
      ></span>
    </div>
    <div class="cropper-button">
      <el-button class="go-back" @click="goBack">返回上一级</el-button>
      <div class="cropper-button-set">
        <el-button class="cropper-confrim" @click="confrimUploadCoverImg"
          >确定</el-button
        >
        <el-button @click="cancelUpdateCover" class="cropper-cancel"
          >取消</el-button
        >
      </div>
    </div>
    <file-uploader-ctrl-vue
      ref="uploader"
      :filePath="filePath"
      :onlyUpload="true"
      @onUploadSuccess="updateCoverImgUrl"
    />
  </el-dialog>
</template>

<script>
import { VueCropper } from 'vue-cropper';
import { modelMixin } from '../../../assets/js/mixins/model';
import OSS from 'ali-oss';
import { getOSS, updateCoverRelicImg } from '../../../api';
import { mapGetters } from 'vuex';
import fileUploaderCtrlVue from '../../layout/file-uploader-ctrl.vue';
import { dataURLtoFile } from '../../../config/utils';
export default {
  name: 'RelicUploadCropper',
  props: {
    imgUrl: {
      type: String,
      required: true
    }
  },
  components: {
    VueCropper,
    fileUploaderCtrlVue
  },
  mixins: [modelMixin],
  computed: {
    ...mapGetters('relic', ['gettersRelicDetail']),
    coverUrl() {
      return this.imgUrl;
    },
    filePath() {
      return `relic/${this.gettersRelicDetail.relicAutoIncrementId}/cover`;
    }
  },
  data() {
    return {
      client: null,
      proportionValue: 0,
      normalValue: 0, //用于放大缩小的对照
      oldValue: '',
      option: {
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 剪切后的图片质量（0.1-1）
        full: true, // 输出原图比例截图 props名full
        outputType: 'png', // 裁剪生成额图片的格式
        canMove: true, // 能否拖动图片
        canMoveBox: false, // 能否拖动截图框
        autoCrop: true, // 是否默认生成截图框
        fixedNumber: [1, 1],
        autoCropWidth: 250,
        autoCropHeight: 250,
        fixedBox: true // 截图框固定大小
      }
    };
  },
  methods: {
    /**
     * 取消上传封面
     */
    cancelUpdateCover() {
      this.modelValue = false;
      this.$emit('onCancelUpdateCover');
    },
    /**
     * 确认上传封面
     */
    confrimUploadCoverImg() {
      this.$refs.cropper.getCropData(data => {
        const fileName = `${this.gettersRelicDetail.relicName}封面.png`;
        const file = dataURLtoFile(data, fileName);

        this.$refs.uploader.handleFileChange({ files: [file] });
      });
    },
    /**
     * 更新封面路径上传至数据库
     */
    updateCoverImgUrl(url) {
      updateCoverRelicImg({
        coverUrl: url,
        relicAutoIncrementId: this.gettersRelicDetail.relicAutoIncrementId
      })
        .then(res => {
          if (res.data.code == 200) {
            this.modelValue = false;
            this.$emit('onLocalUpdateCover');
            this.$emit('onPhotoAlibumUpdateCover');
          } else {
            this.$prompt('上传失败');
          }
        })
        .catch(err => {
          this.$prompt('上传失败');
        });
    },
    /**
     * 返回上一步
     */
    goBack() {
      this.modelValue = false;
    },

    /**
     * 放大
     */
    handleChangeBigger(val) {
      if (0 < this.proportionValue < 100) {
        this.$refs.cropper.changeScale(val);
        this.proportionValue = this.proportionValue + val;
      }
    },
    /**
     * 缩小
     */
    handleChangeSmall(val) {
      if (0 < this.proportionValue < 100) {
        this.$refs.cropper.changeScale(val);
        this.proportionValue = this.proportionValue + val;
      }
    },
    /**
     * 左旋转
     */
    handleChangeLeft() {
      this.$refs.cropper.rotateLeft();
    },
    /**
     * 右旋转
     */
    handleChangeRight() {
      this.$refs.cropper.rotateRight();
    },
    handleChangeSize(val) {
      this.$refs.cropper.changeScale(val - this.normalValue);
      this.normalValue = val;
    }
  }
};
</script>

<style lang="scss">
.relic-upload-cropper {
  width: 340px;
  .el-dialog {
    &__header {
      padding: 0;
    }
    &__body {
      width: 340px;
      height: 430px;
      max-height: 80vh;
      overflow-y: auto;
    }
    &__headerbtn {
      display: flex;
      font-size: 30px;
      color: #fff;
      top: -5px;
      right: -40px;
    }
    &__close {
      color: #fff;
    }
  }
  .cropper-contant {
    width: 100%;
    display: flex;
    justify-content: center;
    .vue-cropper {
      width: 309px;
      height: 309px;
    }
  }
  .cropper-control {
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-weight: 800;
    font-size: 12px;
    height: 38px;
    width: 100%;
    .block {
      width: 150px;
    }
    .el-button {
      width: 20px;
      height: 20px;
    }
    .iconfont {
      font-weight: 800;
    }
  }
  .cropper-button {
    display: flex;
    justify-content: space-between;
    .el-button {
      height: 30px;
    }
    .go-back {
      width: 100px;
    }
    .cropper-confrim {
      background-color: $color-primary;
      color: #fff;
    }
  }
}
</style>
